// extracted by mini-css-extract-plugin
export var button = "Button-module--button--bfb84";
export var disabled = "Button-module--disabled--e8133";
export var small = "Button-module--small--cfb18";
export var xSmall = "Button-module--xSmall--a034d";